var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('SourceCode',{staticClass:"source-code",style:(_vm.codeStyle),attrs:{"language":"javascript"}}),_c('Color',{staticClass:"color",attrs:{"code-style":_vm.codeStyle},on:{"updateColor":_vm.updateColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }